import { jsx } from 'react/jsx-runtime';
import { PlainText, CaptionRegular, PB4Bold, PB4Regular, B4Bold, B4Regular, PB3Bold, PB3Regular, B3Bold, B3Regular, PB2Bold, PB2Regular, B2Bold, B2Regular, PB1Bold, PB1Regular, B1Bold, B1Regular, H10Bold, H10Regular, H9Bold, H9Regular, H8Bold, H8Regular, H7Bold, H7Regular, H6Bold, H6Regular, H5Bold, H5Regular, H4Bold, H4Regular, H3Bold, H3Regular, H2Bold, H2Regular, H1Bold, H1Regular } from './styled.mjs';

var TextComponent = function TextComponent(_ref) {
  var weight = _ref.fontWeight,
    color = _ref.color,
    fontFamily = _ref.fontFamily,
    align = _ref.align,
    border = _ref.border,
    letterSpacing = _ref.letterSpacing,
    subType = _ref.subType_v2,
    children = _ref.children,
    role = _ref.role,
    className = _ref.className,
    onClick = _ref.onClick;
  if (!subType) {
    return jsx(PlainText, {
      children: children
    });
  }
  switch (subType) {
    case "h1Regular":
      return jsx(H1Regular, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "h1Bold":
      return jsx(H1Bold, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "h2Regular":
      return jsx(H2Regular, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "h2Bold":
      return jsx(H2Bold, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "h3Regular":
      return jsx(H3Regular, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "h3Bold":
      return jsx(H3Bold, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "h4Regular":
      return jsx(H4Regular, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "h4Bold":
      return jsx(H4Bold, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "h5Regular":
      return jsx(H5Regular, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "h5Bold":
      return jsx(H5Bold, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "h6Regular":
      return jsx(H6Regular, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "h6Bold":
      return jsx(H6Bold, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "h7Regular":
      return jsx(H7Regular, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "h7Bold":
      return jsx(H7Bold, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "h8Regular":
      return jsx(H8Regular, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "h8Bold":
      return jsx(H8Bold, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "h9Regular":
      return jsx(H9Regular, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "h9Bold":
      return jsx(H9Bold, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "h10Regular":
      return jsx(H10Regular, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "h10Bold":
      return jsx(H10Bold, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "b1Regular":
      return jsx(B1Regular, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "b1Bold":
      return jsx(B1Bold, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "pB1Regular":
      return jsx(PB1Regular, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "pB1Bold":
      return jsx(PB1Bold, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "b2Regular":
      return jsx(B2Regular, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "b2Bold":
      return jsx(B2Bold, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "pB2Regular":
      return jsx(PB2Regular, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "pB2Bold":
      return jsx(PB2Bold, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "b3Regular":
      return jsx(B3Regular, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "b3Bold":
      return jsx(B3Bold, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "pB3Regular":
      return jsx(PB3Regular, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "pB3Bold":
      return jsx(PB3Bold, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "b4Regular":
      return jsx(B4Regular, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "b4Bold":
      return jsx(B4Bold, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "pB4Regular":
      return jsx(PB4Regular, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "pB4Bold":
      return jsx(PB4Bold, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
    case "caption":
      return jsx(CaptionRegular, {
        role: role,
        className: className,
        color: color,
        align: align,
        border: border,
        weight: weight,
        fontFamily: fontFamily,
        letterSpacing: letterSpacing,
        onClick: onClick,
        children: children
      });
  }
};

export { TextComponent };
